<template>
  <div>
    <a-collapse>
      <a-collapse-panel key="1" header="Add / Thêm mới">
        <a-form-model
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          style="margin-top: 10px;"
          :rules="rules"
          ref="ruleForm"
        >
          <a-form-model-item label="Question / Câu hỏi" prop="question">
            <a-input v-model="form.question" placeholder="Enter text..." />
          </a-form-model-item>
          <a-form-model-item label="Answer / Hướng dẫn" prop="answer">
            <VueEditor
              class="ict24h-editor"
              :editor-toolbar="customToolbar"
              placeholder="Enter text..."
              v-model="form.answer"
            />
          </a-form-model-item>
        </a-form-model>
        <div style="text-align: right;">
          <a-button
            :loading="loadingBtn"
            type="primary"
            @click="onSubmitAdding"
          >
            Add
          </a-button>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <div class="ant-descriptions-title" style="margin-top: 15px;">
      <a-icon type="question-circle" /> List QA / Danh mục câu hỏi hỗ trợ
    </div>
    <ListQasHelpdesk
      :refreshAfterUpdatedQA="refreshAfterUpdatedQA"
      :refreshAfterDeletedQA="refreshAfterDeletedQA"
      :idHelpdesk="idHelpdesk"
      :qas="qas"
    />
  </div>
</template>
<script>
import ListQasHelpdesk from "./listQasHelpdesk";
import query from "../constant/query";

const rules = {
  question: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "change",
    },
  ],
  answer: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "change",
    },
  ],
};
export default {
  components: { ListQasHelpdesk },
  props: {
    idHelpdesk: {
      type: String,
      required: true,
    },
    qas: {
      type: Array,
      default: () => {
        return [];
      },
    },
    refreshAfterCreatedQA: {
      type: Function,
      default: () => {},
    },
    refreshAfterDeletedQA: {
      type: Function,
      default: () => {},
    },
    refreshAfterUpdatedQA: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loadingBtn: false,
    };
  },
  methods: {
    onSubmitAdding() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreateHelpdeskQA();
        } else {
          return false;
        }
      });
    },
    onCreateHelpdeskQA() {
      this.loadingBtn = true;
      if (!this.idHelpdesk) {
        throw new Error("Cannot find id heldesk category");
      }
      this.$apollo
        .mutate({
          mutation: query.createHelpdeskQA,
          variables: {
            categoryId: this.idHelpdesk,
            question: this.form.question,
            answer: this.form.answer,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Thêm danh mục hỗ trợ thành công!",
          });
          this.loadingBtn = false;
          this.form = {};
          if (data?.createHelpdeskQA?.id) {
            this.refreshAfterCreatedQA(data.createHelpdeskQA);
          }
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Thêm danh mục hỗ trợ không thành công!",
          });
          console.log("Thêm danh mục hỗ trợ không thành công", err);
        });
    },
  },
};
</script>
<style lang="css" scoped></style>
